import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(( theme ) => ({
  
  container: {
    marginLeft: 2,
    marginRight: 2,
    zIndex: 2,
    borderRadius: 10,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "nowrap",
    boxSizing: "border-box",
  },
  animate: {
    transition: "width 250ms",
  },
  bar: {
    position: "absolute",
    borderRadius: 10,
  },
  label: {
    alignItems: "center",
    display: "flex",
    gap: 2,
    height: "100%",
    left: 0,
    maxWidth: "100%",
    overflow: "hidden",
    padding: "0 6px",
    position: "sticky",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: 12,
  },
  labelText: {
    marginLeft: 8,
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "uppercase",
    fontWeight: 700,
  },
  exceeds: {
    background: `linear-gradient(to left, transparent, ${theme.palette.primary.main} 24px)`,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    paddingRight: 0,
  },
}));

export default useStyle;
